import { cloneDeep, forEach, mapValues, merge } from 'lodash';

import { ColumnsSettings, ColumnsSettingsViewDict, ColumnViewInfo } from '../../typings/common';

export class ColumnsHelpers {
    public static getColumns(
        defaults: Record<
            string,
            {
                columnOrder?: Array<string>;
                columnViewInfo: ColumnViewInfo;
            }
        >,
        storageColumns?: ColumnsSettingsViewDict
    ): ColumnsSettingsViewDict {
        const defaultCopy = mapValues(defaults, defaultsItem => {
            return {
                columnOrder: Object.keys(defaultsItem.columnViewInfo),
                ...cloneDeep(defaultsItem)
            };
        });

        const storageCopy = cloneDeep(storageColumns);

        if (!storageCopy) {
            return defaultCopy;
        }

        forEach(defaultCopy, (value: ColumnsSettings, key) => {
            const storageValue = storageCopy[key];

            if (storageValue) {
                merge(value.columnViewInfo, storageValue.columnViewInfo);

                if (storageValue.columnOrder) {
                    // убираем из существующего порядка колонок в сторедже те, которых нет в дефолтных(на случай удаления колонки)
                    const storageItems = storageValue.columnOrder.filter(item => {
                        return value.columnOrder.includes(item);
                    });
                    // создаем массив новых элементов(те, которые добавились в дефолтные)
                    const newItems = value.columnOrder.filter(item => {
                        return !storageValue.columnOrder.includes(item);
                    });
                    // конкатим массив из стореджа без удаленных колонок и массив новых колонок
                    value.columnOrder = storageItems.concat(newItems);
                }
            }
        });

        return defaultCopy;
    }
}
